module.exports = __webpack_public_path__ + "static/media/spoon-and-fork.24495e77.svg";